module.exports = __webpack_public_path__ + "img/cns_email_mac2.5884da93.png";